
export const user = {
    getById: '/users/getById',
}